import { useState } from "react";
import { auth } from "../firebase";

export default function Feedback({ onBack }) {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    if (!message.trim()) return;
    setSending(true);

    const body = `
Feedback from: ${auth.currentUser?.email}
User ID: ${auth.currentUser?.uid}
Date: ${new Date().toLocaleString()}

${message}
    `.trim();

    // Uses mailto — opens email client with feedback pre-filled
    window.location.href = `mailto:hellosolistravel@gmail.com?subject=Solis Beta Feedback&body=${encodeURIComponent(body)}`;

    setTimeout(() => {
      setSending(false);
      setSent(true);
    }, 1000);
  };

  return (
    <>
      <style>{`
        .fb-root { min-height: 100vh; background: #FAF6F0; font-family: 'DM Sans', sans-serif; }
        .fb-header { background: white; border-bottom: 0.5px solid rgba(26,23,20,0.12); padding: 14px 20px; display: flex; align-items: center; gap: 12px; position: sticky; top: 0; z-index: 100; }
        .fb-back { background: none; border: none; font-size: 22px; cursor: pointer; padding: 0; line-height: 1; }
        .fb-header-title { font-family: 'Playfair Display', serif; font-size: 18px; font-weight: 600; color: #1E2D4A; }
        .fb-content { padding: 28px 20px; }
        .fb-card { background: white; border-radius: 20px; border: 0.5px solid rgba(26,23,20,0.12); padding: 24px; }
        .fb-emoji { font-size: 40px; margin-bottom: 14px; }
        .fb-title { font-family: 'Playfair Display', serif; font-size: 22px; font-weight: 600; color: #1A1714; margin-bottom: 8px; letter-spacing: -0.02em; }
        .fb-sub { font-size: 14px; color: rgba(26,23,20,0.45); font-weight: 300; line-height: 1.6; margin-bottom: 24px; }
        .fb-label { font-size: 12px; font-weight: 500; color: rgba(26,23,20,0.5); text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 8px; }
        .fb-textarea { width: 100%; min-height: 160px; border: 1.5px solid rgba(26,23,20,0.12); border-radius: 14px; padding: 14px; font-size: 15px; font-family: 'DM Sans', sans-serif; color: #1A1714; background: #FAF6F0; resize: none; outline: none; line-height: 1.6; transition: border-color 0.2s; box-sizing: border-box; }
        .fb-textarea:focus { border-color: #F5A623; }
        .fb-textarea::placeholder { color: rgba(26,23,20,0.25); }
        .fb-btn { width: 100%; padding: 15px; background: #1E2D4A; color: white; border: none; border-radius: 14px; font-size: 15px; font-weight: 500; cursor: pointer; font-family: 'DM Sans', sans-serif; margin-top: 14px; transition: all 0.2s; }
        .fb-btn:hover:not(:disabled) { background: #2C3E5E; }
        .fb-btn:disabled { opacity: 0.5; cursor: not-allowed; }
        .fb-success { text-align: center; padding: 40px 0 20px; }
        .fb-success-emoji { font-size: 52px; margin-bottom: 16px; }
        .fb-success-title { font-family: 'Playfair Display', serif; font-size: 22px; font-weight: 600; color: #1A1714; margin-bottom: 8px; }
        .fb-success-sub { font-size: 14px; color: rgba(26,23,20,0.45); font-weight: 300; line-height: 1.6; margin-bottom: 28px; }
        .fb-back-btn { padding: 13px 28px; background: #F5A623; color: #1E2D4A; border: none; border-radius: 100px; font-size: 14px; font-weight: 500; cursor: pointer; font-family: 'DM Sans', sans-serif; }
        .fb-note { font-size: 12px; color: rgba(26,23,20,0.3); text-align: center; margin-top: 12px; line-height: 1.5; }
      `}</style>

      <div className="fb-root">
        <div className="fb-header">
          <button className="fb-back" onClick={onBack}>←</button>
          <span className="fb-header-title">Feedback</span>
        </div>

        <div className="fb-content">
          <div className="fb-card">
            {sent ? (
              <div className="fb-success">
                <div className="fb-success-emoji">📬</div>
                <div className="fb-success-title">Opening your email app…</div>
                <div className="fb-success-sub">Your feedback is pre-filled and ready to go — just hit send and we'll get it!</div>
                <button className="fb-back-btn" onClick={onBack}>Back to app</button>
              </div>
            ) : (
              <>
                <div className="fb-emoji">💬</div>
                <div className="fb-title">Share your thoughts</div>
                <div className="fb-sub">You're one of our first beta users. Tell us what's working, what's broken, or what you wish Solis could do.</div>
                <div className="fb-label">Your feedback</div>
                <textarea
                  className="fb-textarea"
                  placeholder="What's on your mind? Bugs, ideas, anything..."
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                />
                <button
                  className="fb-btn"
                  onClick={handleSubmit}
                  disabled={!message.trim() || sending}
                >
                  {sending ? "Opening email..." : "Send feedback →"}
                </button>
                <div className="fb-note">This will open your email app with your feedback pre-filled and ready to send.</div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}